export const awsExports = {
  'REGION': 'ap-southeast-2',
  'USER_POOL_ID': process.env.REACT_APP_COGNITO_USER_POOL,
  'USER_POOL_APP_CLIENT_ID': process.env.REACT_APP_COGNITO_CLIENT_ID
}